
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaAccessibleIcon, FaUtensils, FaUserFriends, FaMusic, FaTree, FaSwimmer } from 'react-icons/fa';
import Gallery from '../components/Gallery';
import temperley_frente from '../assets/img/Temperley_Frente.jpg'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const Temperley = () => {
  // Imágenes para la galería (en producción se reemplazarían por imágenes reales)
  const galleryImages = [
    { src: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef', alt: 'Centro Temperley - Actividades' },
    { src: 'https://images.unsplash.com/photo-1526662092594-e98c1e356d6a', alt: 'Centro Temperley - Instalaciones' },
    { src: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29', alt: 'Centro Temperley - Exterior' },
    { src: 'https://images.unsplash.com/photo-1615915017998-3cddacc975fd', alt: 'Centro Temperley - Terapia' }
  ];

  return (
    <div className="container">
      <div className="sede-header">
        <h1>Sede Temperley</h1>
        <p>Conoce nuestra sede principal, un espacio diseñado para el desarrollo integral y bienestar de nuestros concurrentes.</p>
      </div>

      <section className="sede-info">
        <div className="sede-details">
          <h2>Sobre nuestra sede</h2>
          <p>Nuestra sede de Temperley fue la primera instalación de Mi Lugar, inaugurada en 1982 por la Lic. Mirtha Wechsung. Ubicada en una zona tranquila y accesible, cuenta con amplias instalaciones especialmente adaptadas para brindar la mejor atención a nuestros concurrentes.</p>
          <p>Disponemos de salas terapéuticas equipadas, espacios recreativos, comedor, áreas verdes y todo lo necesario para desarrollar nuestras actividades en un ambiente seguro y estimulante.</p>

          <div className="sede-contact">
            <h3>Información de contacto</h3>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>A. Gallardo 646, Temperley - Provincia de Buenos Aires</span>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>1165651675</span>
            </div>
          </div>

          <div className="sede-buttons" style={{ marginTop: '20px' }}>
            <a href="https://wa.me/5491165651675" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>

        <div className="sede-image">
          <img src= {temperley_frente} alt="Sede Temperley" />
        </div>
      </section>

      <section className="sede-facilities">
        <h2 className="section-title">Nuestras instalaciones</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaAccessibleIcon className="facility-icon" />
            <div>
              <h3>Accesibilidad total</h3>
              <p>Instalaciones adaptadas para movilidad reducida</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUtensils className="facility-icon" />
            <div>
              <h3>Comedor</h3>
              <p>Servicio de alimentación supervisado</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUserFriends className="facility-icon" />
            <div>
              <h3>Salas terapéuticas</h3>
              <p>Espacios especializados para cada terapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaMusic className="facility-icon" />
            <div>
              <h3>Sala de música</h3>
              <p>Equipada para musicoterapia</p>
            </div>
          </div>
          <div className="facility-item">
            <FaTree className="facility-icon" />
            <div>
              <h3>Espacios verdes</h3>
              <p>Áreas al aire libre para actividades recreativas</p>
            </div>
          </div>
          <div className="facility-item">
            <FaSwimmer className="facility-icon" />
            <div>
              <h3>Actividades acuáticas</h3>
              <p>Programa de hidroterapia</p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Galería de fotos</h2>
        <Gallery images={galleryImages} />
      </section>

      <section className="map-container">
        <h2 className="section-title">¿Cómo llegar?</h2>
        <p>Estamos ubicados en A. Gallardo 646, Temperley, Provincia de Buenos Aires.</p>
        <div style={{ marginTop: '20px' }}>
          <a 
            href="https://www.google.com/maps/search/?api=1&query=A.+Gallardo+646,+Temperley,+Buenos+Aires" 
            className="btn"
            target="_blank" 
            rel="noopener noreferrer"
          >
            <FaMapMarkerAlt /> Ver en Google Maps
          </a>
        </div>
        <div style={{ marginTop: '30px', height: '400px' }}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.632979084912!2d-58.4!3d-34.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQ4JzAwLjAiUyA1OMKwMjQnMDAuMCJX!5e0!3m2!1ses!2sar!4v1634567890123!5m2!1ses!2sar" 
            width="100%" 
            height="100%" 
            style={{ border: 0, borderRadius: '8px' }} 
            allowFullScreen="" 
            loading="lazy"
            title="Mapa Sede Temperley"
          ></iframe>
        </div>
      </section>

       {/* WhatsApp Float Button With Report*/}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651675");
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Temperley;
